export const themeTypes = {
    SET_THEME_MODE: 'SET_THEME_MODE',
    UPDATE_BASE: 'UPDATE_BASE',
    UPDATE_CUSTOM: 'UPDATE_CUSTOM',
}
